import React from 'react';

import OfferCard, { OfferCardList } from '../../../HireSummary/OfferCard';
import { normalizeOffer } from '../../../HireSummary/hireValues';

export type PottencialSelectCardProps = {
  setSelected: (selected: string) => void;
  selected: string;
  offers: {
    status?: string;
    nomeSeguro: string;
    planoSelecionado: string;
    valorParcela: number;
    premioTotal: number;
    quantidadeParcela: number;
  }[];
};

// Helper function to check if product status is rejected
const isRejected = (status?: string): boolean => {
  if (!status) return false;
  const rejectedStatuses = ['denied', 'refused', 'refusedbiometry', 'expired'];
  return rejectedStatuses.some(rejected => status.toLowerCase().includes(rejected));
};

export const PottencialSelectCards = ({
  offers,
  selected,
  setSelected
}: PottencialSelectCardProps) => (
  <OfferCardList>
    {offers &&
      offers.map((option, i) => {
        const isDisabled = isRejected(option.status) || !(option.valorParcela > 0);

        return (
          <OfferCard
            key={i}
            name="pottencial-plan"
            offer={normalizeOffer(option)}
            selected={selected === option.nomeSeguro}
            disabled={isDisabled}
            onSelect={() => setSelected(option.nomeSeguro)}
          />
        );
      })}
  </OfferCardList>
);
export default PottencialSelectCards;
